import { render, staticRenderFns } from "./HealthIndicatorCard.vue?vue&type=template&id=2c291ca6&scoped=true&"
import script from "./HealthIndicatorCard.vue?vue&type=script&lang=js&"
export * from "./HealthIndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthIndicatorCard.vue?vue&type=style&index=0&id=2c291ca6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c291ca6",
  null
  
)

export default component.exports